import { getSessionMiniature } from 'src/utils';
import { Session } from 'src/models/Session';
import { Challenge } from 'src/models/Challenge';
import { ChallengesService, SessionsService } from 'src/services';
import { BackNavigationInfo } from 'src/models/BackNavigationInfo';

export const resolveTypeName = (entity: Session | Challenge) =>
  entity.contentType === 'challenge'
    ? undefined
    : entity.type?.[0]?.name ?? '';

export const resolveImage = (session: Session | Challenge) => {
  if (session.horizontalThumbnail) return session.horizontalThumbnail;
  const fromVideo = getSessionMiniature(session.video?.thumbnail, 800);
  if (fromVideo) return fromVideo;
  if ('verticalThumbnail' in session && session.verticalThumbnail) {
    return session.verticalThumbnail;
  }
  return undefined;
};

export const resolveDuration = (mode: 'horizontal' | 'vertical', entity: Session | Challenge) => {
  if (mode === 'horizontal') {
    return entity.video?.duration ?? undefined;
  } else if ('duration' in entity) {
    return entity.duration ?? undefined;
  }
};

export const composeLink = (item?: Session | Challenge, backInfo?: BackNavigationInfo) => {
  if (!item) {
    return
  }
  const pathname = `${item.contentType === 'session' ? '/sessions' : '/challenges'}/${item.id}`;
  const queryParam = backInfo ? BackNavigationInfo.serializeToUrlParams(backInfo) : '';

  return `${pathname}${queryParam ? `?${queryParam}` : ''}`;
};

export const toggleLike = async (item: Session | Challenge, status: boolean) => {
  if (item?.contentType === 'session') {
    await SessionsService.toggleLiked(item.id, status);
    return;
  }
  if (item?.contentType === 'challenge') {
    await ChallengesService.toggleChallengeLiked(item.id, status);
    return;
  }
  throw new Error('Could not toggle like');
};
